var React = require('react');

function LevelUpAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M232 160v328a24 24 0 0 1-24 24H12a12 12 0 0 1-8.48-20.48l56-56A12 12 0 0 1 68 432h84V160z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M88 160c-20.94 0-31.76-25-17.6-40.33l104-112c.4-.43.82-.86 1.26-1.26a24 24 0 0 1 33.91 1.26l104 112C327.82 135 316.84 160 296 160z","className":"fa-primary","key":2})]);
}

LevelUpAlt.defaultProps = {"viewBox":"0 0 320 512","className":"icon"};

module.exports = LevelUpAlt;

LevelUpAlt.default = LevelUpAlt;
